export const generateChatId = () => crypto.randomUUID();
